export default __webpack_public_path__ + "static/media/img4.7c24ab0e.png";